import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import IndividualCart from "./IndividualCart";
import IndividualAddress from "./Address";
import TableContainer from "../../../components/Common/TableContainer";
import { PaymentStatus,LogStatus } from "../../Dashboard/LatestTranactionCol";
import toast from "react-hot-toast";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import EcommerceOrdersPaymentModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersPaymentModal";
import EcommerceOrdersTrackingModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersTrackingModal";



const IndividualDetail = () => {
  const { id } = useParams();
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;


  const [customer, setCustomer] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loginRecords, setloginRecords] = useState([]);
  const [customerModal, setCustomerModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("non-gst");
  const [registerAs, setRegisterAs] = useState("non-gst");
  const [status, setStatus] = useState("Inactive");
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "1"
  );
  const [paymentDetailsModel, setPaymentDetailsModal] = useState(false);
  const [trackingDetailsModel, setTrackingDetailsModal] = useState(false);

  // 🔹 Fetch individual customer detail
  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const res = await fetch(`${baseurl}/admin/customer/individuals/${id}`);
        const data = await res.json();
console.log(data);
        if (data.success) {
          setCustomer(data.data);
          
          setActiveTab("1");
          setRegisterAs(data.data.created_at || "non-gst");
          setStatus(data.data.status || "Inactive");
        } else {
          toast.error("Customer not found!");
        }
        // Mark cart as viewed
      await fetch(
        `${baseurl}/admin/customer/individuals/${id}/viewed`,
        {
          method: "PUT",
        }
      );

      } catch (error) {
        console.error("Fetch customer error:", error);
        toast.error("Error fetching customer details.");
      }
    };
    fetchCustomer();
  }, [id, baseurl]);

  // 🔹 Fetch user orders
  useEffect(() => {
    
    const fetchloginRecords = async () => {
      try {
        const res = await fetch(`${baseurl}/admin/customer/individuals/loginrecords/${customer?.userid}`);
        const data = await res.json();
        if (data.success) setloginRecords(data.data.logs);
      } catch (err) {
        console.error("Fetch orders error:", err);
      }
    };
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${baseurl}/admin/customer/individuals/orders/${customer?.userid}`);
        const data = await res.json();
        if (data.success) setOrders(data.data.orders);
      } catch (err) {
        console.error("Fetch orders error:", err);
      }
    };


    fetchOrders();
    fetchloginRecords();

    
  }, [customer, baseurl]);

  // 🔹 Table columns for orders
  const columns = useMemo(
    () => [
      {
        Header: "Order ID",
        accessor: "order_id",
        disableFilters: true,
      },
      {
        Header: "Total",
        accessor: "total_amount",
        disableFilters: true,
      },
      {
        Header: "Payment Status",
        accessor: "payment_status",
        disableFilters: true,
        Cell: (cellProps) => <PaymentStatus {...cellProps} />,
      },
      {
        Header: "Payment Mode",
        accessor: "payment_mode",
        disableFilters: true,
      },
      {
        Header: "Order Status",
        accessor: "order_status",
        disableFilters: true,
      },
      {
        Header: "Date",
        accessor: "created_at",
        disableFilters: true,
      },
      {
        Header: "View Details",
        disableFilters: true,
        accessor: "view",
        Cell: (cellProps) => {
          const orderId = cellProps.row.original.order_id;
          return (
            <div className="d-flex gap-3 align-items-center">
              <Link
                to={`/manage-orders/individual-customer/order-details/${orderId}`}
                className="text-success"
              >
                <i className="mdi mdi-eye-outline font-size-18" id="viewtooltip"></i>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              {/* <Link
                to="#"
                className="text-success"
                onClick={() => handleDownloadInvoice(orderId)}
              >
                <i className="bx bxs-download font-size-18" id="downloadtooltip"></i>
                <UncontrolledTooltip placement="top" target="downloadtooltip">
                  Download invoice
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={toggleTrackingDetailsViewModal}
              >
                <i className="bx bxs-truck font-size-18" id="trackingbutton" />
                <UncontrolledTooltip placement="top" target="trackingbutton">
                  Tracking Details
                </UncontrolledTooltip>
              </Link> */}
            </div>
          );
        },
      },
    ],
    []
  );

  // 🔹 Table columns for orders
  const logcolumns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "created_at",
        disableFilters: true,
      },{
        Header: "IP Address",
        accessor: "ip_address",
        disableFilters: true,
      },
      {
        Header: "User Agent",
        accessor: "user_agent",
        disableFilters: true,
      },
      {
        Header: "Status",
        accessor: "status",
        disableFilters: true,
        Cell: (cellProps) => <LogStatus {...cellProps} />,
      },
      
      
     
    ],
    []
  );

  // 🔹 Download invoice handler
  const handleDownloadInvoice = async (orderId) => {
    try {
      const res = await fetch(`${baseurl}/api/orders/invoice/${orderId}`);
      const data = await res.json();

      if (data.success && data.data.file_url) {
        window.open(data.data.file_url, "_blank");
      } else {
        toast.error("Invoice not found");
      }
    } catch (error) {
      console.error("Invoice download error:", error);
      toast.error("Error generating invoice");
    }
  };

  // 🔹 Validation
  const validationSchema = Yup.object({
  discount: Yup.number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0")
    .max(100, "Discount cannot be more than 100")
    .required("Discount is required"),

  industry: Yup.string()
    .trim()
    .required("Industry is required"),

  customer_type: Yup.string()
    .trim()
    .required("Customer type is required"),

  customer_category: Yup.string()
    .trim()
    .required("Customer category is required"),

  status: Yup.string()
    .oneOf(
      ["Active", "Inactive"],
      "Invalid status"
    )
    .required("Status is required"),
});

  // 🔹 Modal toggles
  const toggleModal = () => setModal(!modal);
  const toggleRegisterModal = () => setShowModal(!showModal);
  const toggleCustomerModal = () => setCustomerModal(!customerModal);
  const togglePaymentDetailsViewModal = () => setPaymentDetailsModal(!paymentDetailsModel);
  const toggleTrackingDetailsViewModal = () => setTrackingDetailsModal(!trackingDetailsModel);

  // 🔹 Update customer handler
  const handleSubmit = async (values, { setSubmitting }) => {
  try {
    const res = await fetch(
      `${baseurl}/admin/customer/corporates/${customer.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );

    const data = await res.json();

     

    if (data.success) {
      toast.success("Customer updated successfully");

      // 🔥 Update local state so UI updates instantly
      setCustomer(prev => ({
        ...prev,
        ...data.data,
      }));

      toggleCustomerModal();
    } else {
      toast.error(data.message || "Update failed");
    }
  } catch (error) {
    console.error("Update customer error:", error);
    toast.error("Something went wrong");
  } finally {
    setSubmitting(false);
  }
};


  // 🔹 Change status handler
  const handleStatusChange = () => {
    setStatus(status === "Active" ? "Inactive" : "Active");
    toggleModal();
  };

  if (!customer) return <div>Loading...</div>;

  document.title = "Individual customer details | Vekarts";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Manage Customers" breadcrumbItem="Customer Details" />

        {/* Payment + Tracking Modals */}
        <EcommerceOrdersPaymentModal
          isOpen={paymentDetailsModel}
          toggle={togglePaymentDetailsViewModal}
        />
        <EcommerceOrdersTrackingModal
          isOpen={trackingDetailsModel}
          toggle={toggleTrackingDetailsViewModal}
        />

        {/* CUSTOMER BASIC INFO */}
        <Row>
          <Col lg="3">
            <Card>
              <CardBody className="text-center d-flex justify-content-center align-items-center">
                {customer.image ? (
                  <img
                    src={`${imgurl}${customer.image}`}
                    alt="Profile"
                    className="rounded-circle"
                    width="100"
                    height="100"
                  />
                ) : (
                  <div
                    style={{
                      width: "200px",
                      height: "200px",
                      borderRadius: "50%",
                      backgroundColor: "#ddd",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "80px",
                      fontWeight: "bold",
                      color: "#555",
                    }}
                  >
                    {customer.company_name?.slice(0, 2).toUpperCase()}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          <Col lg="9">
            <table className="table table-bordered bg-light">
              <tbody>
                <tr>
                  <th>Customer ID</th>
                  <td>{customer.id}</td>
                </tr>
                <tr>
                  <th>Company Name</th>
                  <td>{customer.company_name || "N/A"}</td>
                </tr>
                <tr>
                  <th>GST Number</th>
                  <td>{customer.gst_number || "N/A"}</td>
                </tr>
                <tr>
                  <th>PAN Card Number</th>
                  <td>{customer.pan_number || "N/A"}</td>
                </tr>
                <tr>
                  <th>Industry</th>
                  <td>{customer.industry || "N/A"}</td>
                </tr>
                <tr>
                  <th>Customer Type</th>
                  <td>{customer.customer_type || "N/A"}</td>
                </tr>
                <tr>
                  <th>Customer Category</th>
                  <td>{customer.customer_category || "N/A"}</td>
                </tr>
                <tr>
                  <th>Discount</th>
                  <td>{customer.discount || "0"} %</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    <span className={`badge ${customer.status === "Active" ? "bg-success" : "bg-danger"}`}>
                      {customer.status}
                    </span>
                    <Link to="#" onClick={toggleCustomerModal} className="ms-2 text-success">
                      <i className="mdi mdi-pencil font-size-18"></i>
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>

        {/* Tabs */}
        <Nav tabs className="my-3">
          <NavItem>
            <NavLink
              className={activeTab === "1" ? "active" : ""}
              onClick={() => setActiveTab("1")}
            >
              Details
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "2" ? "active" : ""}
              onClick={() => setActiveTab("2")}
            >
              Address
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "3" ? "active" : ""}
              onClick={() => setActiveTab("3")}
            >
              Cart
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "4" ? "active" : ""}
              onClick={() => setActiveTab("4")}
            >
              Orders
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "5" ? "active" : ""}
              onClick={() => setActiveTab("5")}
            >
              Login Records
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Content */}
        <TabContent activeTab={activeTab}>
          {/* Details */}
          <TabPane tabId="1">
            <Card>
              <CardBody>
                <Row>
                  <Col lg="12"> 
                    <h5 style={{ marginBottom: "10px" }}>Manage Customer</h5> 
                  </Col> 
                </Row> 
                <Row> 
                  <Col lg="12"> 
                    <div className="table-responsive"> 
                      {customer.users && customer.users.length > 0 ? (
  <table
    className="table table-bordered"
    style={{
      backgroundColor: "#f8f9fa",
      border: "1px solid #ddd",
      borderRadius: "8px",
      width: "100%",
      marginBottom: "20px",
    }}
  >
    <thead>
      <tr>
        <th>Username</th>
        <th>Designation</th>
        <th>Mobile No.</th>
        <th>Email Address</th>
        {/* <th className="text-center">Action</th> */}
      </tr>
    </thead>
    <tbody>
      {customer.users.map((user, index) => (
        <tr key={index}>
          <td>{user.name}</td>
          <td>{user.designation}</td>
          <td>{user.mobile_number}</td>
          <td>{user.email}</td>
          {/* <td className="text-center">
            <Link to="#" className="text-success" onClick={toggleCustomerModal}>
              <i className="mdi mdi-pencil font-size-18" id={`editbutton-${index}`} />
              <UncontrolledTooltip placement="top" target={`editbutton-${index}`}>
                Edit Customer
              </UncontrolledTooltip>
            </Link>
          </td> */}
        </tr>
      ))}
    </tbody>
  </table>
) : (
  <p>No users available.</p>
)} 
                    </div> 
                  </Col> 
                </Row>
                
                
              </CardBody>
            </Card>
          </TabPane>


          <TabPane tabId="2">
            <Card>
              <CardBody>
                <Row> 
                  <Col lg="12"> 
                  <IndividualAddress userId={customer?.userid} />
                  
                  </Col>
                  </Row>
                
              </CardBody>
            </Card>
          </TabPane>

          {/* Cart */}
          <TabPane tabId="3">
            <Card>
              <CardBody>
                  <IndividualCart userId={customer?.userid} />
                 
              </CardBody>
            </Card>
          </TabPane>

          {/* Orders */}
          <TabPane tabId="4">
            <Card>
              <CardBody>
                <h5>Orders</h5>
                <TableContainer
                  columns={columns}
                  data={orders}
                  isGlobalFilter={true}
                  customPageSize={10}
                />
              </CardBody>
            </Card>
          </TabPane>

          {/* Login Records */}
          <TabPane tabId="5">
            <Card>
              <CardBody>
                <h5>Login Records</h5>

                <TableContainer
                  columns={logcolumns}
                  data={loginRecords}
                  isGlobalFilter={true}
                  customPageSize={10}
                />
                
              </CardBody>
            </Card>
          </TabPane>
        </TabContent>

        {/* Edit Customer Modal */}
        <Modal isOpen={customerModal} toggle={toggleCustomerModal} centered>
          <ModalHeader toggle={toggleCustomerModal}>Edit Customer</ModalHeader>
          <Formik
            initialValues={{
              discount: customer?.discount || "",
              customer_category: customer?.customer_category || "",
              industry: customer?.industry || "",
              customer_type: customer?.customer_type || "",
              status: customer.status || "Active",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <ModalBody>
                  
                  <div className="mb-3">
                    <label>Discount (%)</label>
                    <Field name="discount" className="form-control" />
                    <ErrorMessage name="discount" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                    <label>Customer Category</label>
                    <Field as="select" name="customer_category" className="form-control" required>
                      <option value="">Select Customer Category</option>
                      <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                     
                    </Field>
                    <ErrorMessage name="customer_category" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                    <label>Industry</label>
                    <Field as="select" name="industry" className="form-control" required>
                      <option value="">Select Industry Type</option>
                      <option value="Chemical">Chemical</option>
                        <option value="Oil & Gas">Oil & Gas</option>
                        <option value="Pharma">Pharma</option>
                        <option value="Fertilizer">Fertilizer</option>
                        <option value="Food & Beverages">Food & Beverages</option>
                        <option value="Water">Water</option>
                        <option value="Renewable">Renewable</option>
                        <option value="Infra">Infra</option>
                        <option value="Automobile">Automobile</option>
                        <option value="Cement">Cement</option>
                        <option value="Pulp & Paper">Pulp & Paper</option>
                        <option value="FMCG">FMCG</option>
                        <option value="System Integrator">System Integrator</option>
                        <option value="Education">Education</option>
                        <option value="ITOT">ITOT</option>
                        <option value="Textile">Textile</option>
                        <option value="Metal">Metal</option>
                     
                    </Field>
                    <ErrorMessage name="industry" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                    <label>Customer Type</label>
                    <Field as="select" name="customer_type" className="form-control" required>
                      <option value="">Select Customer Type</option>
                      <option value="End User">End User</option>
                      <option value="OEM">OEM</option>
                      <option value="CP/SI">CP/SI</option>
                      <option value="EPC">EPC</option>
                      <option value="DEC">DEC</option>
                      <option value="Trader">Trader</option>
                    </Field>
                    <ErrorMessage name="customer_type" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                    <label>Status</label>
                    <Field as="select" name="status" className="form-control">
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Field>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="danger" onClick={toggleCustomerModal}>
                    Cancel
                  </Button>
                  <Button type="submit" color="primary" disabled={isSubmitting}>
                    Save Changes
                  </Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </Modal>
      </Container>
    </div>
  );
};

export default IndividualDetail;
